import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import { isMobile } from "react-device-detect";
import BgSound from "../../../assets/topstudio/audio/TpbgSound.mp3";
import "../../../assets/topstudio/styles/Poker.css";
import PokerResult from "./tp-result/PokerResult.jsx";
import PokerRules from "./pop-up/poker-rules.jsx";


import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function Poker() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);
  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [pairAVal, setPairAVal] = useState(0);
  const [pairBVal, setPairBVal] = useState(0);

  // PAIR PLUS A values (b3-b10)
  const [b3Val, setB3Val] = useState(0); // One Pair- A
  const [b4Val, setB4Val] = useState(0); // Two Pair- A
  const [b5Val, setB5Val] = useState(0); // Three Of A Kind- A
  const [b6Val, setB6Val] = useState(0); // Straight- A
  const [b7Val, setB7Val] = useState(0); // Flush- A
  const [b8Val, setB8Val] = useState(0); // Full House- A
  const [b9Val, setB9Val] = useState(0); // Four Of A Kind- A
  const [b10Val, setB10Val] = useState(0); // Straight Flush- A

  // PAIR PLUS B values (b11-b18)
  const [b11Val, setB11Val] = useState(0); // One Pair- B
  const [b12Val, setB12Val] = useState(0); // Two Pair- B
  const [b13Val, setB13Val] = useState(0); // Three Of A Kind- B
  const [b14Val, setB14Val] = useState(0); // Straight- B
  const [b15Val, setB15Val] = useState(0); // Flush- B
  const [b16Val, setB16Val] = useState(0); // Full House- B
  const [b17Val, setB17Val] = useState(0); // Four Of A Kind- B
  const [b18Val, setB18Val] = useState(0); // Straight Flush- B

  const [lastStatus, setLastStatus] = useState(null);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [isNarrowViewport, setIsNarrowViewport] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= 768
  );
  const useMobileBetSlip = isMobile || isNarrowViewport;
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [roundId, setRoundId] = useState("");
  const [winnerA, setWinnerA] = useState(false);
  const [winnerB, setWinnerB] = useState(false);
  const [isPair1, setIsPair1] = useState(false);
  const [isPair2, setIsPair2] = useState(false);

  const [playerABook, setPlayerABook] = useState(0);
  const [playerBBook, setPlayerBBook] = useState(0);
  const [playerAPlusBook, setPlayerAPlusBook] = useState(0);
  const [playerBPlusBook, setPlayerBPlusBook] = useState(0);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [soundEnabled, setSoundEnabled] = useState(false);

  const sessionUser = useSelector((s) => s.userStore.data);

  const bgAudioRef = useRef(null);

  const [resultData, setResultData] = useState([]);

  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= FLIP STATE ================= */
  const [flipStep, setFlipStep] = useState(0);
  const flipTimerRef = useRef(null);
  const lastFlipKeyRef = useRef(null);

  const updateUserData = async (userData) => {
    //await dispatch(setUserData(userData));
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  /* ================= DISPLAYED CARDS (IMPORTANT) ================= */
  const [shownCards, setShownCards] = useState({
    ac1: "1",
    ac2: "1",
    ac3: "1",
    bc1: "1",
    bc2: "1",
    bc3: "1"
  });

  const [shownCards1, setShownCards1] = useState({
    cc1: "1",
    cc2: "1",
    cc3: "1",
    cc4: "1",
    cc5: "1",
    ac1: "1",
    ac2: "1"
  });

  const [shownCards2, setShownCards2] = useState({
    bc1: "1",
    bc2: "1"
  });

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "Poker_virtual"
  });

  //console.log("data->", data);

  const displayRunnerName = (runnerName, displayTxt) => {
    const runnerLabels = {
      b1: "Player A",
      b2: "Player B",
      pairA: "Player A+",
      pairB: "Player B+",
      b3: "One Pair- A",
      b4: "Two Pair- A",
      b5: "Three Of A Kind- A",
      b6: "Straight- A",
      b7: "Flush- A",
      b8: "Full House- A",
      b9: "Four Of A Kind- A",
      b10: "Straight Flush- A",
      b11: "One Pair- B",
      b12: "Two Pair- B",
      b13: "Three Of A Kind- B",
      b14: "Straight- B",
      b15: "Flush- B",
      b16: "Full House- B",
      b17: "Four Of A Kind- B",
      b18: "Straight Flush- B"
    };
    if (runnerLabels[runnerName]) return runnerLabels[runnerName];
    if (displayTxt) {
      return String(displayTxt)
        .split(" ")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
    }
    return runnerName || "";
  };

  /// place bet ///

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const payload = data?.data?.data;
  const payloadResult = data?.data?.result;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const [displayLoader, setDisplayLoader] = useState(true);
  //console.log("payload->", payload);

  /* ================= TIMER SYNC ================= */
  useEffect(() => {
    if (!payload) return;
    updateUserData(data?.user);
    setDisplayLoader(false);

    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setWinnerA(false);
      setWinnerB(false);
      setIsPair1(false);
      setIsPair2(false);
      setPlayerABook(0);
      setPlayerBBook(0);
      setPlayerAPlusBook(0);
      setPlayerBPlusBook(0);
      // Reset reveal so CLOSED never paints with a leftover high flipStep
      clearTimeout(flipTimerRef.current);
      lastFlipKeyRef.current = null;
      setFlipStep(0);
      setShownCards1({
        cc1: "1",
        cc2: "1",
        cc3: "1",
        cc4: "1",
        cc5: "1",
        ac1: "1",
        ac2: "1"
      });
      setShownCards2({
        bc1: "1",
        bc2: "1"
      });
    }
    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    const leftTime = Number(payload?.left_time);
    if (Number.isNaN(leftTime)) return;

    setB1Val(payload?.b1 || 0);
    setB2Val(payload?.b2 || 0);
    setPairAVal(payload?.pairA || 0);
    setPairBVal(payload?.pairB || 0);

    // PAIR PLUS A
    setB3Val(payload?.b3 || 0);
    setB4Val(payload?.b4 || 0);
    setB5Val(payload?.b5 || 0);
    setB6Val(payload?.b6 || 0);
    setB7Val(payload?.b7 || 0);
    setB8Val(payload?.b8 || 0);
    setB9Val(payload?.b9 || 0);
    setB10Val(payload?.b10 || 0);

    // PAIR PLUS B
    setB11Val(payload?.b11 || 0);
    setB12Val(payload?.b12 || 0);
    setB13Val(payload?.b13 || 0);
    setB14Val(payload?.b14 || 0);
    setB15Val(payload?.b15 || 0);
    setB16Val(payload?.b16 || 0);
    setB17Val(payload?.b17 || 0);
    setB18Val(payload?.b18 || 0);

    setTimeLeft(leftTime);
    setRoundId(payload?.cat_mid);

    if (payload?.result == 1 || payload?.result == "1") {
      setWinnerA(true);
      setWinnerB(false);
    } else if (payload?.result == 2 || payload?.result == "2") {
      setWinnerA(false);
      setWinnerB(true);
    }

    if (payload?.isPair1 == 1 || payload?.isPair1 == "1") {
      setIsPair1(true);
    } else {
      setIsPair1(false);
    }
    if (payload?.isPair2 == 1 || payload?.isPair2 == "1") {
      setIsPair2(true);
    } else {
      setIsPair2(false);
    }

    clearInterval(localTimerRef.current);

    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "poker_virtual"
    });
    let books = res?.data;
    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        let obj = books[i];

        if (obj.Type === "main") {
          setPlayerABook(obj.PlayerA);
          setPlayerBBook(obj.PlayerB);
        }

        if (obj.Type === "pairA") {
          setPlayerAPlusBook(obj.PlayerAPlus);
        }
        if (obj.Type === "pairB") {
          setPlayerBPlusBook(obj.PlayerBPlus);
        }
      }
    }
  }

  useEffect(
    () => () => {
      clearInterval(localTimerRef.current);
    },
    []
  );

  /* ================= FLIP SEQUENCE ================= */
  useEffect(() => {
    if (!payload?.evt_status || !payload?.cat_mid) return;

    clearTimeout(flipTimerRef.current);

    // Never advance flipStep while OPEN — leftover high flipStep causes a
    // one-frame flash of all cards when CLOSED arrives.
    if (payload.evt_status !== "CLOSED") {
      lastFlipKeyRef.current = null;
      setFlipStep(0);
      return () => clearTimeout(flipTimerRef.current);
    }

    const flipKey = `${payload.cat_mid}:CLOSED`;
    if (lastFlipKeyRef.current === flipKey) return;
    lastFlipKeyRef.current = flipKey;

    setFlipStep(0);

    let step = 0;

    function run() {
      // Parse community cards if provided as string
      let communityCards = [];
      if (
        payload?.community_card &&
        typeof payload.community_card === "string"
      ) {
        communityCards = payload.community_card
          .split(",")
          .map((card) => card.trim());
      }

      const getCc = (i) =>
        communityCards.length > 0 ? communityCards[i] : payload?.[`cc${i + 1}`];

      // 1: Player A first card
      if (step === 1) {
        setShownCards1((prev) => ({ ...prev, ac1: payload?.ac1 }));
      }
      // 2: Player B first card
      if (step === 2) {
        setShownCards2((prev) => ({ ...prev, bc1: payload?.bc1 }));
      }
      // 3: Player A second card
      if (step === 3) {
        setShownCards1((prev) => ({ ...prev, ac2: payload?.ac2 }));
      }
      // 4: Player B second card
      if (step === 4) {
        setShownCards2((prev) => ({ ...prev, bc2: payload?.bc2 }));
      }
      // 5: Flop — first three community cards together
      if (step === 5) {
        setShownCards1((prev) => ({
          ...prev,
          cc1: getCc(0),
          cc2: getCc(1),
          cc3: getCc(2)
        }));
      }
      // 6: Turn — 4th community card
      if (step === 6) {
        setShownCards1((prev) => ({ ...prev, cc4: getCc(3) }));
      }
      // 7: River — 5th community card
      if (step === 7) {
        setShownCards1((prev) => ({ ...prev, cc5: getCc(4) }));
      }

      setFlipStep(step + 1);
      step++;

      if (step <= 7) {
        flipTimerRef.current = setTimeout(run, 1000);
      }
    }

    flipTimerRef.current = setTimeout(run, 1500);

    return () => clearTimeout(flipTimerRef.current);
  }, [payload?.evt_status, payload?.cat_mid]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  const showBetfairBetSlip = (bettype, teamname, selectRnr, price) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "poker_virtual"
    };
    placeBetObject.catmid = payload?.cat_mid;
    placeBetObject.round = payload?.cat_mid;

    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 7;

    setPlaceBetObject(placeBetObject);
    if (useMobileBetSlip) {
      setShowBetSlip(false);
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlipPopup(false);
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };
  /// place bet ///
  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };
  const closeBetSlip = () => {
    setShowBetSlip(false);
  };
  const [profileData, setProfileData] = useState(null);

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  const playBGSoundWithRetry = () => {
    const audio = bgAudioRef.current;
    if (!audio) return;
    audio.play().catch(() => {
      setTimeout(() => audio.play().catch(() => {}), 250);
    });
  };

  const toggleSound = (e) => {
    const on = e.target.checked;
    setSoundEnabled(on);
    if (on) {
      playBGSoundWithRetry();
    } else {
      bgAudioRef.current?.pause();
    }
  };

  const [initialBetsFetched, setInitialBetsFetched] = useState(false);
  const [placedBets, setPlacedBets] = useState([]);
  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const placedBets = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "poker_virtual"
    });

    setPlacedBets(placedBets.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsNarrowViewport(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  const getCardImage = (cardValue, reveal) => {
    return reveal && cardValue && cardValue !== "1" ? cardValue : null;
  };

  // Parse community cards from string if needed
  const getCommunityCard = (key) => {
    if (payload?.community_card && typeof payload.community_card === "string") {
      const communityCards = payload.community_card
        .split(",")
        .map((card) => card.trim());
      const index = parseInt(key.replace("cc", "")) - 1;
      return communityCards[index] || payload?.[key];
    }
    return payload?.[key];
  };

  const communityKeys = ["cc1", "cc2", "cc3", "cc4", "cc5"];

  // Build gameData structure like the original HTML
  const buildGameData = () => {
    const gameData = [];

    // Community Cards - Always show 5 card slots
    let communityCards = [];
    if (payload?.community_card && typeof payload.community_card === "string") {
      const cards = payload.community_card
        .split(",")
        .map((card) => card.trim());
      communityCards = cards.map((card) => ({
        value: card && card !== "1" ? card : null
      }));
    }
    // Fill with empty slots if less than 5 cards
    while (communityCards.length < 5) {
      communityCards.push({ value: null });
    }

    gameData.push({
      name: "Community Cards",
      status: "",
      property: communityCards
    });

    // Player A - Always show 2 card slots
    const playerACards = [
      { value: payload?.ac1 && payload.ac1 !== "1" ? payload.ac1 : null },
      { value: payload?.ac2 && payload.ac2 !== "1" ? payload.ac2 : null }
    ];

    gameData.push({
      name: "Player A",
      status: "",
      property: playerACards
    });

    // Player B - Always show 2 card slots
    const playerBCards = [
      { value: payload?.bc1 && payload.bc1 !== "1" ? payload.bc1 : null },
      { value: payload?.bc2 && payload.bc2 !== "1" ? payload.bc2 : null }
    ];

    gameData.push({
      name: "Player B",
      status: "",
      property: playerBCards
    });

    return gameData;
  };

  useEffect(() => {
    document.documentElement.classList.add("poker-bg-black");
    document.documentElement.classList.add("h-100");

    return () => {
      document.documentElement.classList.remove("poker-bg-black");
      document.documentElement.classList.remove("h-100");
    };
  }, []);

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "Poker_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <>
      {showBetSlipPopup && useMobileBetSlip && (
        <TPPopUpBetSlip
          closeBetSlipParent={closeBetSlipMobile}
          betObj={placeBetObject}
          placeBetParent={placeBet}
          betButtonShow={betButtonShow}
          betErrorMessageObj={betErrorMessageObj}
          betButtonShowLoaderShow={betButtonShowLoaderShow}
          profileData={profileData}
        />
      )}
      {shownCards && (
        <div className="access-poker poker-bg-black h-100 aviator-scope player-scope">
          <ClientLayoutWithOutHeader showLoader={false}>
            <div class="details-tabs-wrapper1">
              <div className="main-page">
                <div className="row no-gutters">
                  <div className="col-md-12">
                    <div className="bodyheight">
                      <div className="wrapper">
                        <TPStudioSidebar open={open} />
                      </div>

                      <div className="lobby-ctn BPGmaindiv">
                        <TpStudioHeader setOpen={setOpen} open={open} />
                        <TpStudioLoader displayLoader={displayLoader} />
                      </div>

                      <div
                        className="row"
                        style={{ display: displayLoader ? "none" : "" }}
                      >
                        <div className="col-md-8">
                          <div className="left-content">
                            <div>
                              <div>
                                <div
                                  className="col-12 timerDiv2"
                                  style={{ marginBottom: "-24px" }}
                                >
                                  <div
                                    className="footer-divbpg border-gradient-footer border-gradient-purple-footer"
                                    style={{ height: "45px" }}
                                  >
                                    <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                      <p style={{ fontSize: "17px" }}>Poker</p>
                                    </div>
                                    <div
                                      className="col-6 col-md-6 inline-block Gameidcol text-right"
                                      style={{ marginTop: "2px" }}
                                    >
                                      <div
                                        role="group"
                                        aria-label="Second group"
                                        className="btn-group btn-group-sm mr-2"
                                      >
                                        <button
                                          style={{ fontSize: "14px" }}
                                          type="button"
                                          id="Alltab"
                                          className={
                                            activeTabIndex == 1
                                              ? "tablink btn btn-primary bbactive"
                                              : "tablink btn btn-primary"
                                          }
                                          onClick={() => activeTab(1)}
                                        >
                                          Game
                                        </button>
                                        <button
                                          style={{ fontSize: "14px" }}
                                          type="button"
                                          id="RESULTStab"
                                          className={
                                            activeTabIndex == 2
                                              ? "tablink btn btn-primary bbactive"
                                              : "tablink btn btn-primary"
                                          }
                                          onClick={() => activeTab(2)}
                                        >
                                          Results
                                        </button>
                                        <button
                                          style={{ fontSize: "14px" }}
                                          type="button"
                                          className="tablink btn btn-primary"
                                          onClick={() => setShowRules(true)}
                                        >
                                          Rules
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    className="row mt-2"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    <div className="col-2 col-md-1">
                                      <div className="Connectedclients mt-1">
                                        <i
                                          aria-hidden="true"
                                          className="fa fa-user mr-1"
                                          style={{
                                            fontSize: "14px",
                                            color: "white"
                                          }}
                                        />
                                        <b>
                                          <span
                                            id="UsersCount"
                                            className="number"
                                          >
                                            326
                                          </span>
                                        </b>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-8" />
                                  <div
                                    className="col-md-2"
                                    style={{
                                      display: activeTabIndex == 1 ? "" : "none"
                                    }}
                                  >
                                    {/* Timer with animated stroke + numeric countdown */}
                                    <div className="teenpatti-base-timer">
                                      <svg
                                        viewBox="0 0 100 100"
                                        className="base-timer__svg"
                                      >
                                        <g className="base-timer__circle">
                                          <circle
                                            cx="50"
                                            cy="50"
                                            r="45"
                                            className="base-timer__path-elapsed"
                                          />
                                          <path
                                            strokeDasharray={`${Math.round(
                                              dash
                                            )} ${Math.round(CIRC)}`}
                                            className={`base-timer__path-remaining ${timerColor}`}
                                            d="
                                                    M 50, 50
                                                    m -45, 0
                                                    a 45,45 0 1,0 90,0
                                                    a 45,45 0 1,0 -90,0
                                                  "
                                          />
                                        </g>
                                      </svg>
                                      <span className="base-timer__label">
                                        {payload?.left_time == 1
                                          ? 0
                                          : payload?.left_time}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div
                                  className="cards-layout blackjack"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none",
                                    position: "relative"
                                  }}
                                >
                                  <audio ref={bgAudioRef} src={BgSound} loop />

                                  <div
                                    className="table-player poker-table-layout"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "100%"
                                    }}
                                  >
                                    {/* Community Cards */}
                                    <div
                                      className="poker-community-player"
                                      style={{
                                        textAlign: "center",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center"
                                      }}
                                    >
                                      <span className="name">
                                        Community Cards
                                      </span>
                                      <div
                                        className="poker-community-hand"
                                        style={{
                                          position: "relative",
                                          width: "fit-content",
                                          height: "fit-content",
                                          minHeight: "80px",
                                          margin: "2px auto",
                                          padding: isMobile
                                            ? "6px 14px"
                                            : "6px 20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: 0,
                                          borderRadius: "12px",
                                          border:
                                            "1px solid rgba(178, 220, 175, 0.25)",
                                          overflow: "visible"
                                        }}
                                      >
                                        {communityKeys.map((key, index) => {
                                          const cardValue =
                                            getCommunityCard(key);
                                          const cardW = isMobile
                                            ? Math.round(46 * 1.2 * 0.8)
                                            : Math.round(70 * 1.2 * 0.8);
                                          const cardH = 80;
                                          // Fan: left tilts left, right tilts right
                                          const rotations = [-10, -5, 0, 5, 10];
                                          const yOffsets = [6, 2, 0, 2, 6];
                                          const peek = isMobile ? 22 : 30;
                                          // Flop (cc1–cc3) together at step 5, turn at 6, river at 7
                                          const revealAt =
                                            index < 3 ? 5 : index + 3;

                                          return (
                                            <div
                                              key={key}
                                              className="poker-community-card"
                                              style={{
                                                position: "relative",
                                                display: "block",
                                                width: cardW,
                                                height: cardH,
                                                flexShrink: 0,
                                                marginLeft:
                                                  index > 0
                                                    ? -(cardW - peek)
                                                    : 0,
                                                zIndex: index + 1,
                                                transform: `rotate(${rotations[index]}deg) translateY(${yOffsets[index]}px)`,
                                                transformOrigin: "bottom center"
                                              }}
                                            >
                                              {flipStep >= revealAt &&
                                                payload?.evt_status ===
                                                  "CLOSED" &&
                                                cardValue &&
                                                cardValue !== "1" && (
                                                  <img
                                                    src={`/assets/galaxy/img/cards3/${cardValue}.svg`}
                                                    draggable={false}
                                                    alt=""
                                                    style={{
                                                      width: "100%",
                                                      height: "100%",
                                                      borderRadius: "6px",
                                                      display: "block"
                                                    }}
                                                  />
                                                )}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>

                                    {/* Player A and Player B - Second Row */}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        gap: "20px",
                                        width: "100%",
                                        flexWrap: "nowrap"
                                      }}
                                    >
                                      {[
                                        {
                                          name: "Player A",
                                          cards: [
                                            { value: payload?.ac1, step: 1 },
                                            { value: payload?.ac2, step: 3 }
                                          ]
                                        },
                                        {
                                          name: "Player B",
                                          cards: [
                                            { value: payload?.bc1, step: 2 },
                                            { value: payload?.bc2, step: 4 }
                                          ]
                                        }
                                      ].map((player) => (
                                        <div
                                          className="tp20-player"
                                          key={player.name}
                                          style={{
                                            width: "auto",
                                            maxWidth: "none",
                                            flex: "0 0 auto"
                                          }}
                                        >
                                          <span className="name">
                                            {player.name}
                                          </span>
                                          <div
                                            className="poker-player-hand"
                                            style={{
                                              position: "relative",
                                              width: "fit-content",
                                              height: "fit-content",
                                              minHeight: "80px",
                                              margin: "2px auto",
                                              padding: isMobile
                                                ? "6px 14px"
                                                : "6px 20px",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              gap: 0,
                                              borderRadius: "12px",
                                              border:
                                                "1px solid rgba(178, 220, 175, 0.25)",
                                              overflow: "visible"
                                            }}
                                          >
                                            {player.cards.map((card, index) => {
                                              const cardW = isMobile
                                                ? Math.round(46 * 1.2 * 0.8)
                                                : Math.round(70 * 1.2 * 0.8);
                                              const cardH = 80;
                                              const rotations = [-6, 6];
                                              const peek = isMobile ? 24 : 32;
                                              return (
                                                <div
                                                  key={index}
                                                  className="poker-player-card"
                                                  style={{
                                                    position: "relative",
                                                    display: "block",
                                                    width: cardW,
                                                    height: cardH,
                                                    flexShrink: 0,
                                                    marginLeft:
                                                      index > 0
                                                        ? -(cardW - peek)
                                                        : 0,
                                                    zIndex: index + 1,
                                                    transform: `rotate(${rotations[index]}deg)`,
                                                    transformOrigin:
                                                      "bottom center"
                                                  }}
                                                >
                                                  {flipStep >= card.step &&
                                                    payload?.evt_status ===
                                                      "CLOSED" &&
                                                    card.value &&
                                                    card.value !== "1" && (
                                                      <img
                                                        src={`/assets/galaxy/img/cards3/${card.value}.svg`}
                                                        draggable={false}
                                                        alt=""
                                                        style={{
                                                          width: "100%",
                                                          height: "100%",
                                                          borderRadius: "6px",
                                                          display: "block"
                                                        }}
                                                      />
                                                    )}
                                                </div>
                                              );
                                            })}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                  {/* Controls removed (auto mode) */}
                                </div>
                              </div>
                            </div>

                            <div
                              className="tp20-sound-wrap"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <label
                                htmlFor="Tp20Soundcontrol"
                                className={`fa fa-inverse sound-icon ${
                                  soundEnabled
                                    ? "fa-volume-up"
                                    : "fa-volume-off"
                                }`}
                                title="Toggle sound"
                              >
                                <input
                                  id="Tp20Soundcontrol"
                                  type="checkbox"
                                  checked={soundEnabled}
                                  onChange={toggleSound}
                                  style={{ display: "none" }}
                                />
                              </label>
                            </div>

                            {/* Footer */}
                            <center
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                                <div className="buttons-div">
                                  {Object.keys(resultList).map((idx) => (
                                    <button
                                      key={idx}
                                      className="video-button border-gradient-btn border-gradient-purple-btn"
                                    >
                                      {resultList[idx] == 1 ? "A" : "B"}
                                    </button>
                                  ))}
                                </div>
                                <div className="round-div">
                                  <div className="label">Round ID:</div>
                                  <div className="id">{roundId}</div>
                                </div>
                              </div>
                            </center>

                            {/* Market Sections (unchanged) */}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div
                                className="tb-content"
                                style={{ background: "#fff" }}
                              >
                                <div className="market-titlebar">
                                  <p className="market-name">
                                    <span className="market-name-badge">
                                      <i className="market-name-icon">
                                        <img
                                          src="/assets/images/time-img.png"
                                          style={{
                                            filter: "invert(100%)",
                                            marginTop: "-8px",
                                            marginLeft: "-1px"
                                          }}
                                        />
                                      </i>
                                      <span>MAIN </span>
                                      {/*-<span style="text-transform: initial;">
                                                          (MaxBet: 5M) </span></span> <span class="rules-badge"><i class="fa fa-info-circle"></i></span>-*/}
                                    </span>
                                  </p>
                                  <div className="market-overarround">
                                    <span />
                                    <strong>Back</strong>
                                  </div>
                                  <div className="market-overarround market-overarround-lay">
                                    <strong>Lay</strong>
                                  </div>
                                </div>
                                <div className="market-runners">
                                  <div
                                    className="runner-runner"
                                    style={{ height: "auto" }}
                                  >
                                    <h3
                                      className={
                                        winnerA && flipStep >= 8
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                      id="b1Sucess"
                                    >
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: 0,
                                                      fontWeight: "bold",
                                                      fontSize: "16px"
                                                    }}
                                                    className="clippable-spacer"
                                                  >
                                                    Player A
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus1"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        playerABook !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        playerABook > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(
                                                      playerABook
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          {suspendedText}
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        id="runner1b1span"
                                        data-teamname="Player A"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "player a",
                                            "player a",
                                            b1Val
                                          )
                                        }
                                      >
                                        <span className="price-odd">
                                          {b1Val}
                                        </span>
                                        <span
                                          className="price-amount"
                                          id="rate1"
                                        >
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                  <div
                                    className="runner-runner"
                                    style={{ height: "auto" }}
                                  >
                                    <h3
                                      className={
                                        winnerB && flipStep >= 8
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                      id="b2Sucess"
                                    >
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: 0,
                                                      fontWeight: "bold",
                                                      fontSize: "16px"
                                                    }}
                                                    className="clippable-spacer"
                                                  >
                                                    Player B
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus2"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        playerBBook !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        playerBBook > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(
                                                      playerBBook
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          {suspendedText}
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        id="runner1b2span"
                                        data-teamname="Player B"
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "player b",
                                            "player b",
                                            b2Val
                                          )
                                        }
                                      >
                                        <span className="price-odd">
                                          {b2Val}
                                        </span>
                                        <span
                                          className="price-amount"
                                          id="rate1"
                                        >
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div style={{ height: "5px" }}></div>

                            {/* PAIR PLUS A */}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>PAIR PLUS A </span>
                                  </span>
                                </p>

                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                {[
                                  {
                                    name: "One Pair- A",
                                    value: b3Val,
                                    betName: "one pair a"
                                  },
                                  {
                                    name: "Two Pair- A",
                                    value: b4Val,
                                    betName: "two pair a"
                                  },
                                  {
                                    name: "Three Of A Kind- A",
                                    value: b5Val,
                                    betName: "three of a kind a"
                                  },
                                  {
                                    name: "Straight- A",
                                    value: b6Val,
                                    betName: "straight a"
                                  },
                                  {
                                    name: "Flush- A",
                                    value: b7Val,
                                    betName: "flush a"
                                  },
                                  {
                                    name: "Full House- A",
                                    value: b8Val,
                                    betName: "full house a"
                                  },
                                  {
                                    name: "Four Of A Kind- A",
                                    value: b9Val,
                                    betName: "four of a kind a"
                                  },
                                  {
                                    name: "Straight Flush- A",
                                    value: b10Val,
                                    betName: "straight flush a"
                                  }
                                ].map((item, idx) => (
                                  <div
                                    key={idx}
                                    className="runner-runner"
                                    style={{ height: "auto" }}
                                  >
                                    <h3 className="runner-name">
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <h4
                                            style={{
                                              marginBottom: 0,
                                              fontWeight: "bold",
                                              fontSize: "16px"
                                            }}
                                            className="clippable-spacer"
                                          >
                                            {item.name}
                                          </h4>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          {suspendedText}
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        data-teamname={item.name}
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            item.betName,
                                            item.betName,
                                            item.value
                                          )
                                        }
                                      >
                                        <span className="price-odd">
                                          {item.value}
                                        </span>
                                        <span className="price-amount">
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            <div style={{ height: "5px" }}></div>

                            {/* PAIR PLUS B */}
                            <div
                              className="bg-white"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="market-titlebar">
                                <p className="market-name">
                                  <span className="market-name-badge">
                                    <i className="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>PAIR PLUS B </span>
                                  </span>
                                </p>

                                <div className="market-overarround">
                                  <span />
                                  <strong>Back</strong>
                                </div>
                                <div className="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div className="market-runners">
                                {[
                                  {
                                    name: "One Pair- B",
                                    value: b11Val,
                                    betName: "one pair b"
                                  },
                                  {
                                    name: "Two Pair- B",
                                    value: b12Val,
                                    betName: "two pair b"
                                  },
                                  {
                                    name: "Three Of A Kind- B",
                                    value: b13Val,
                                    betName: "three of a kind b"
                                  },
                                  {
                                    name: "Straight- B",
                                    value: b14Val,
                                    betName: "straight b"
                                  },
                                  {
                                    name: "Flush- B",
                                    value: b15Val,
                                    betName: "flush b"
                                  },
                                  {
                                    name: "Full House- B",
                                    value: b16Val,
                                    betName: "full house b"
                                  },
                                  {
                                    name: "Four Of A Kind- B",
                                    value: b17Val,
                                    betName: "four of a kind b"
                                  },
                                  {
                                    name: "Straight Flush- B",
                                    value: b18Val,
                                    betName: "straight flush b"
                                  }
                                ].map((item, idx) => (
                                  <div
                                    key={idx}
                                    className="runner-runner"
                                    style={{ height: "auto" }}
                                  >
                                    <h3 className="runner-name">
                                      <div className="runner-info">
                                        <span className="clippable runner-display-name">
                                          <h4
                                            style={{
                                              marginBottom: 0,
                                              fontWeight: "bold",
                                              fontSize: "16px"
                                            }}
                                            className="clippable-spacer"
                                          >
                                            {item.name}
                                          </h4>
                                        </span>
                                      </div>
                                    </h3>
                                    <div className="price-row-box-new">
                                      {isSuspended && (
                                        <div
                                          className="runner-disabled2"
                                          id="suspendCls1"
                                        >
                                          {suspendedText}
                                        </div>
                                      )}
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a
                                        className="price-price price-back mb-show span1details"
                                        data-teamname={item.name}
                                        data-bettype="b"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            item.betName,
                                            item.betName,
                                            item.value
                                          )
                                        }
                                      >
                                        <span className="price-odd">
                                          {item.value}
                                        </span>
                                        <span className="price-amount">
                                          {stakeLimit}
                                        </span>
                                      </a>
                                      <a className="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                      <a className="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              display: activeTabIndex == 2 ? "" : "none",
                              color: "white"
                            }}
                          >
                            <PokerResult resultData={resultData} />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <TeenPattisCasinoBetslipWeb
                            showBetSlip={showBetSlip && !useMobileBetSlip}
                            placeBetObject={placeBetObject}
                            closeBetSlipParent={closeBetSlip}
                            placeBetParent={placeBet}
                            betErrorMessageObj={betErrorMessageObj}
                            profileData={profileData}
                          ></TeenPattisCasinoBetslipWeb>
                          <div>
                            <div className="bets">
                              <strong style={{ fontSize: "16px" }}>
                                Matched Bets ({placedBets.length})
                                <img
                                  src={reconnecting}
                                  alt="dc"
                                  className="rounded disconnected"
                                  style={{ display: "none" }}
                                />{" "}
                              </strong>
                              <div className="betting-table">
                                <table className="table">
                                  <thead>
                                    <tr style={{ fontSize: "16px" }}>
                                      <th>Runner</th>
                                      <th>Price</th>
                                      <th>Size</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {placedBets.map((bet, index) => (
                                      <tr
                                        key={index}
                                        style={{
                                          background:
                                            bet.type == "b"
                                              ? "#e9f6fc"
                                              : "#fce3e4"
                                        }}
                                      >
                                        <td>
                                          {displayRunnerName(
                                            bet.rnr,
                                            bet.displayTxt
                                          )}
                                        </td>
                                        <td>{bet.rate}</td>
                                        <td>{bet.amnt}</td>
                                        <td></td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <PokerRules show={showRules} onClose={() => setShowRules(false)} />
          </ClientLayoutWithOutHeader>

          <style>
            {`

.access-poker.poker-bg-black .tb-content{
  padding-top:3px;
}

.access-poker.poker-bg-black .cards-layout.blackjack {
  position: relative;
  background: #000000;
}

.access-poker.poker-bg-black .cards-layout.blackjack::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: radial-gradient(
    ellipse 100% 44% at 50% 30%,
    rgba(62, 193, 65, 0.95) 0%,
    rgba(62, 193, 65, 0.8) 15%,
    rgba(30, 80, 35, 0.5) 40%,
    #1e1e1e 55%,
    #1e1e1e 100%
  );
  opacity: 0.4;
  pointer-events: none;
  z-index: 0;
}

.access-poker.poker-bg-black .cards-layout.blackjack > * {
  position: relative;
  z-index: 1;
}

.access-poker.poker-bg-black .timerDiv2 .col-md-2 {
  position: relative;
  top: -15px;
  right: -12px;
}

.access-poker.poker-bg-black .table-player.poker-table-layout {
  gap: 10px !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0 !important;
}

.access-poker.poker-bg-black .poker-community-player {
  width: 100% !important;
  max-width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  text-align: center !important;
  color: #d7bc7b;
  font-size: 12px;
  font-weight: 700;
}

.access-poker.poker-bg-black .poker-community-player .name,
.access-poker.poker-bg-black .tp20-player .name {
  display: block;
  text-align: center;
  width: 100%;
  margin-bottom: 0;
  padding-bottom: 0;
}

.access-poker.poker-bg-black .poker-community-hand {
  margin-left: auto !important;
  margin-right: auto !important;
}

.access-poker.poker-bg-black .tp20-player {
  width: auto !important;
  max-width: calc(50% - 5px);
  flex: 0 0 auto;
  min-width: 0;
}

.access-poker.poker-bg-black .tp-hand {
  width: 220px !important;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

.access-poker.poker-bg-black .timerDiv2 > .footer-divbpg {
  margin-top: 2px;
}

.access-poker.poker-bg-black center > .footer-divbpg {
  position: relative;
  z-index: 2;
  margin-top: 0;
  background: linear-gradient(180deg, #464646, #0f0f0f);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 45px;
  border: 2px solid;
  border-image-slice: 1 !important;
  border-image-source: linear-gradient(
    180deg,
    rgba(207, 141, 46, 0.47),
    #cf8d2e 50%,
    rgba(207, 141, 46, 0.47)
  );
  box-sizing: border-box;
}

.access-poker.poker-bg-black center {
  display: block;
  width: 100%;
  position: relative;
  z-index: 2;
  clear: both;
}

.access-poker.poker-bg-black center > .footer-divbpg .buttons-div {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100%;
  overflow-x: auto;
}

.access-poker.poker-bg-black center > .footer-divbpg .video-button {
  padding: 0;
  background-color: #4f4f4f !important;
  color: #fff !important;
  font-size: 12px !important;
  font-weight: 500;
  height: 35px !important;
  min-width: 35px !important;
  width: auto !important;
  margin-right: 3px;
  text-align: center;
  border: none;
  border-bottom: 1px solid #1a1a1a !important;
  border-right: 1px solid #1a1a1a !important;
  border-radius: 0 !important;
  flex-shrink: 0;
  pointer-events: none;
}

.access-poker.poker-bg-black center > .footer-divbpg .round-div {
  margin-right: 4px;
  color: #fff;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  justify-content: center;
  white-space: nowrap;
  flex-shrink: 0;
}

.access-poker.poker-bg-black center > .footer-divbpg .round-div .label {
  color: rgba(255, 255, 255, 0.85);
}

.access-poker.poker-bg-black .tp20-sound-wrap {
  position: relative;
  height: 0;
  /* Keep icon overlay without pulling the Round ID footer into Player A/B cards */
  margin-top: 0;
  z-index: 4;
}

.access-poker.poker-bg-black .tp20-sound-wrap .sound-icon {
  position: absolute;
  right: 18px;
  top: -28px;
  cursor: pointer;
  color: #fff;
  z-index: 4;
  width: 15px;
  height: 15px;
  font-size: 15px;
  line-height: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ---------------- DESKTOP ---------------- */

@media (min-width:992px){

  .access-poker.poker-bg-black .table-player{
    font-size:60px !important;
  }

  .access-poker.poker-bg-black .table-player .player-name{
    font-size:13px;
  }

  .access-poker.poker-bg-black .market-titlebar .market-name-badge span,
  .access-poker.poker-bg-black .market-titlebar .market-overarround strong,
  .access-poker.poker-bg-black .market-titlebar .market-overarround-lay strong{
    font-size:14px;
  }

  .access-poker.poker-bg-black .row{
    margin-left:0 !important;
    margin-right:0 !important;
  }

  .access-poker.poker-bg-black .col-md-8{
    padding-left:19px !important;
    margin-bottom:9px;
  }

  .access-poker.poker-bg-black .left-content{
    padding-right:6px;
  }
      .access-poker.poker-bg-black .col-12{
    padding-left:0 !important;
    padding-right:0 !important;
  }

  .access-poker.poker-bg-black .left-content .market-titlebar {
    width: 100%;
    display: flex;
    height: 20px;
}

.access-poker.poker-bg-black .runner-runner .lobby-btn {
   height: 38px !important;
   min-height: 38px !important;
   padding: 2px 4px !important;
}

.access-poker.poker-bg-black .cards-layout.blackjack {
   min-height: 270px;
   padding-bottom: 4px;
   box-sizing: border-box;
}
.access-poker.poker-bg-black .volume-wrapper {
   margin-top: 0;
}
  

}

/* ---------------- MOBILE---------------- */

@media (max-width:991px){

  .access-poker.poker-bg-black .table-player{
    font-size:16px !important;
  }

  .access-poker.poker-bg-black .market-titlebar strong{
    font-size:13px;
  }

  .access-poker.poker-bg-black .col-md-8{
    padding-left:15px !important;
  }

  .access-poker.poker-bg-black .left-content{
    padding-right:0;
  }

}
 @media (max-width:576px){
  .access-poker.poker-bg-black .footer-divbpg{
    display:flex;
    align-items:center;
    justify-content:space-between;
    flex-wrap:nowrap; 
    border-radius:8px;
  }
  .player-scope .tp-card {
    position: absolute;
    top: 10px;
  }
    .access-poker.poker-bg-black .col-12{
    padding-left:0 !important;
    padding-right:0 !important;
  }
  .access-poker.poker-bg-black .titlebarname p{
    font-size:18px !important;
  }
    .access-poker.poker-bg-black .table-player.poker-table-layout {
      justify-content: center !important;
      align-items: center !important;
      gap: 10px !important;
      padding: 0 10px !important;
   }
  .access-poker.poker-bg-black .btn-group-sm .btn{
    padding:2px 6px;
    font-size:12px;
  }
  .access-poker.poker-bg-black .btn-group{
    flex-wrap:nowrap !important;
  }
    .access-poker.poker-bg-black .footer-divbpg .btn-group-sm .btn{
    padding:6px 4px !important;
    font-size:12px !important;
    line-height:1.2;
    margin-top: 0;
  }
  .access-poker.poker-bg-black .footer-divbpg .titlebarname{
    flex:1;         
    max-width:none !important;
    padding-left:4px;
  }
  .access-poker.poker-bg-black .titlebarname p{
    font-size:17px !important;
    margin:0;
    margin-bottom: 12px;
    margin-left: 18px;
  }
    .access-poker.poker-bg-black .table-player.poker-table-layout{
    justify-content: center !important;
    align-items: center !important;
    gap:10px;
    padding:0 10px !important;
  }
  .access-poker.poker-bg-black .poker-community-player{
    width: 100% !important;
    max-width: 100% !important;
    align-items: center !important;
  }
  .access-poker.poker-bg-black .tp20-player{
    width: auto !important;
    max-width: calc(50% - 5px);
  }
  .access-poker.poker-bg-black .tp-hand{
    width: min(180px, calc(50vw - 28px)) !important;
    max-width: 100%;
    height: 83px;
  }
  @scope (.access-poker.poker-bg-black) {
    center > .footer-divbpg .video-button {
      padding: 0;
      background-color: #4f4f4f !important;
      color: #fff !important;
      font-size: 12px !important;
      font-weight: 500;
      height: 35px !important;
      min-width: 35px !important;
      width: auto !important;
      margin-right: 3px;
      text-align: center;
      border-radius: 0 !important;
      border-bottom: 1px solid #1a1a1a !important;
      border-right: 1px solid #1a1a1a !important;
    }
  }
}
  @media (max-width: 768px) {

   .access-poker.poker-bg-black .cards-layout.blackjack {
      min-height: 240px !important;
      padding-bottom: 6px !important;
   }

   .access-poker.poker-bg-black .timerDiv2 {
      margin-bottom: 0 !important;
   }

   .access-poker.poker-bg-black .timerDiv2 .col-md-2 {
      top: -6px;
   }

   .access-poker.poker-bg-black .timerDiv2 .footer-divbpg {
      margin-top: 0 !important;
   }

   .access-poker.poker-bg-black .table-player {
      margin-bottom: 2px !important;
   }

   .access-poker.poker-bg-black .table-player.poker-table-layout {
      margin-top: 0 !important;
   }

   .access-poker.poker-bg-black center > .footer-divbpg {
      margin-top: 0 !important;
   }

   .access-poker.poker-bg-black .volume-wrapper {
      margin-top: 0 !important;
   }
}
  
`}
          </style>
        </div>
      )}
    </>
  );
}
